import { createContext, useContext, useState, useEffect, useMemo } from "react";
import Colors from "../../constants/Colors";

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
    const [currentTheme, setCurrentTheme] = useState(() => {
        const savedTheme = localStorage.getItem('app-theme');
        if (savedTheme) return savedTheme;

        //Try getting the system's configuration to apply the mode (If there's no user selection stored)
        return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    });

    useEffect(() => {
        const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        const handleChange = (e) => {
            if (!localStorage.getItem('app-theme')) {
                setCurrentTheme(e.matches ? 'dark' : 'light');
                // console.log("Current theme: ", currentTheme);
            }
        }

        mediaQuery.addEventListener('change', handleChange);
        return () => mediaQuery.removeEventListener('change', handleChange);
    }, []);

    const toggleTheme = () => {
        const newTheme = currentTheme === 'light' ? 'dark' : 'light';
        setCurrentTheme(newTheme);
        localStorage.setItem('app-theme', newTheme);    //Save user's preference in their browser.
    }

    const theme = useMemo(() => Colors[currentTheme], [currentTheme]);

    const value = {currentTheme, theme, toggleTheme, isDark: currentTheme === 'dark'};

    return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
};

export const useTheme = () => useContext(ThemeContext);